import styled from 'styled-components'

export const DetectionsContainer = styled.div`
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
  margin-top: 8px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  max-width: 800px;
  min-width: 900px;
  min-height: 500px;

  @media (max-height: 600px) {
    min-width: 490px;
  }
`
